(function () {
  'use strict';

  if (typeof window === 'undefined') return;
  if (typeof gsap === 'undefined' || typeof SplitText === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger, SplitText);

  /**
   * Convert a phrasing element (<p>, <h2>, etc.) into a <div> so SplitText
   * can safely inject block-level line wrappers without invalid nesting or
   * browser auto-closing issues that break line positions.
   */
  function toSplitContainer(el) {
    if (!el || el.tagName === 'DIV') return el;

    var div = document.createElement('div');
    // Preserve classes and inline styles
    div.className = el.className;
    div.style.cssText = el.style.cssText;
    // Keep semantics for headings
    if (/^H[1-6]$/i.test(el.tagName)) {
      div.setAttribute('role', 'heading');
      div.setAttribute('aria-level', el.tagName.substring(1));
    }
    div.innerHTML = el.innerHTML;

    if (el.parentNode) {
      el.parentNode.replaceChild(div, el);
    }

    return div;
  }

  /**
   * Wrap each element in an overflow:hidden container for mask effects.
   */
  function wrapInMask(elements) {
    var wrappers = [];
    elements.forEach(function (el) {
      var wrapper = document.createElement('div');
      wrapper.style.display = 'inline-block';
      wrapper.style.overflow = 'hidden';
      wrapper.style.verticalAlign = 'top';
      wrapper.style.maxWidth = '100%';
      if (el.parentNode) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
      }
      wrappers.push(wrapper);
    });
    return wrappers;
  }

  /**
   * Split text into lines, wrap each line in a mask, and reveal on scroll.
   */
  function lineRevealOnScroll(selector, options) {
    var defaults = {
      start: 'top 80%',
      stagger: 0.05,
      duration: 0.4,
      yPercent: 50,
      rotation: 6,
      opacity: 0,
    };
    var opts = Object.assign({}, defaults, options || {});

    var elements = gsap.utils.toArray(selector);
    elements.forEach(function (wrapper) {
      // Find the actual text element to split (headings/paragraphs inside the wrapper).
      // Convert it to a <div> first to avoid block-level line wrappers being inserted
      // inside <p> or <h2> tags, which causes line position bugs.
      var target = wrapper.querySelector('h1, h2, h3, h4, h5, h6, p');
      if (!target) {
        target = wrapper;
      }
      var container = toSplitContainer(target);

      // Force block layout for accurate line splitting and avoid flex-related line bugs
      container.style.display = 'block';

      var split = new SplitText(container, { type: 'lines', linesClass: 'split-line' });
      wrapInMask(split.lines);

      gsap.set(split.lines, {
        yPercent: opts.yPercent,
        rotation: opts.rotation,
        opacity: opts.opacity,
      });

      ScrollTrigger.create({
        trigger: container,
        start: opts.start,
        once: true,
        onEnter: function () {
          gsap.to(split.lines, {
            yPercent: 0,
            rotation: 0,
            opacity: 1,
            duration: opts.duration,
            stagger: opts.stagger,
            ease: 'power3.out',
            transformOrigin: 'left center',
          });
        },
      });
    });
  }

  function initStoryScrollReveals() {
    // Headings
    lineRevealOnScroll('.text-block.h2-effect', {
      start: 'top 80%',
      stagger: 0.05,
      duration: 0.4,
      yPercent: 50,
      opacity: 0,
      rotation: 6,
    });

    // Paragraphs
    lineRevealOnScroll('.text-block.p-effect', {
      start: 'top 80%',
      stagger: 0.05,
      duration: 0.4,
      yPercent: 50,
      opacity: 0,
      rotation: 12,
    });

    // Large quote
    lineRevealOnScroll('.text-block.testimonials-large', {
      start: 'top 80%',
      stagger: 0.05,
      duration: 0.4,
      yPercent: 50,
      opacity: 0,
      rotation: 6,
    });

    // Remove the loading class now that everything is set up
    document.documentElement.classList.remove('js-loading-story');
  }

  initStoryScrollReveals();
})();
